export default {
  // Hero Section
  'hero.badge': 'Asian Alley Mini Mall — Riga, Latvia',
  'hero.title.line1': 'Chợ Hẻm',
  'hero.title.line2': 'Asian Alley',
  'hero.description': 'Thuê Kiosk kinh doanh hàng Châu Á ngay tại trung tâm Riga — Không cần kinh nghiệm, không cần rành ngôn ngữ, chúng tôi hỗ trợ toàn bộ!',
  'hero.price': 'Chỉ từ',
  'hero.priceDay': '10 EUR/ngày',
  'hero.priceOr': 'hoặc',
  'hero.priceMonth': '150 EUR/tháng',
  'hero.cta.register': 'Đăng Ký Thuê Kiosk Ngay',
  'hero.cta.viewTypes': 'Xem Các Loại Kiosk',
  'hero.stats.price': 'Giá thuê/ngày',
  'hero.stats.size': 'Kích thước từ',
  'hero.stats.support': 'Hỗ trợ toàn diện',

  // Intro Section
  'intro.badge': 'Giải Pháp Cho Bạn',
  'intro.title.line1': 'Bạn Đang Gặp',
  'intro.title.line2': 'Những Khó Khăn Này?',
  'intro.problem1': 'Muốn tự làm chủ nhưng không biết bắt đầu từ đâu?',
  'intro.problem2': 'Không rành ngôn ngữ địa phương?',
  'intro.problem3': 'Không biết hồ sơ, giấy tờ cần thiết?',
  'intro.problem4': 'Chưa có địa điểm kinh doanh ổn định?',
  'intro.solution.title': 'Asian Alley Mini Mall sẽ hỗ trợ bạn!',
  'intro.solution.desc': 'Chúng tôi cung cấp không gian kinh doanh sẵn sàng, hỗ trợ giấy tờ, ngôn ngữ và vận hành — để bạn chỉ cần tập trung bán hàng.',
  'intro.imageCaption': '✨ Asian Alley Mini Mall',
  'intro.imageSubCaption': 'Trung tâm thương mại hàng Châu Á — Riga, Latvia',

  // Product Categories Section
  'categories.badge': 'Ngành Hàng Kinh Doanh',
  'categories.title.line1': 'Các Mặt Hàng',
  'categories.title.line2': 'Phù Hợp',
  'categories.subtitle': 'Chợ Hẻm Asian Alley chuyên về hàng hóa và dịch vụ Châu Á — thị trường ngách đang bùng nổ tại châu Âu',
  'categories.swipeHint': 'Vuốt sang để xem thêm',
  'categories.cat1.title': 'Thủ Công Mỹ Nghệ',
  'categories.cat1.desc': 'Đồ thủ công, tranh ảnh, đồ lưu niệm, sản phẩm truyền thống Châu Á độc đáo thu hút khách du lịch và người dân địa phương.',
  'categories.cat1.tag': 'Phổ biến',
  'categories.cat2.title': 'Quần Áo & Vải Vóc',
  'categories.cat2.desc': 'Thời trang Châu Á, vải truyền thống, áo dài, kimono, hanbok và các loại vải đặc trưng từ Việt Nam, Nhật, Hàn, Trung Quốc.',
  'categories.cat2.tag': 'Bán chạy',
  'categories.cat3.title': 'Trang Sức & Phụ Kiện',
  'categories.cat3.desc': 'Vòng tay, dây chuyền, hoa tai, trâm cài tóc, túi xách và phụ kiện thời trang Châu Á tinh tế, giá cả phải chăng.',
  'categories.cat3.tag': 'Lợi nhuận cao',
  'categories.cat4.title': 'Dụng Cụ Nhà Bếp',
  'categories.cat4.desc': 'Nồi đất, chảo wok, bộ ấm trà, đũa, bát đĩa gốm sứ và các dụng cụ nấu ăn Châu Á được người châu Âu yêu thích.',
  'categories.cat4.tag': 'Nhu cầu cao',
  'categories.cat5.title': 'Dịch Vụ',
  'categories.cat5.desc': 'Cắt tóc, gội đầu, làm móng, massage, chăm sóc da theo phong cách Châu Á — dịch vụ được người châu Âu rất ưa chuộng.',
  'categories.cat5.tag': 'Dịch vụ',

  // Kiosk Types Section
  'kiosk.badge': 'Bảng Giá Thuê',
  'kiosk.title': 'Các Loại',
  'kiosk.titleHighlight': 'Kiosk',
  'kiosk.subtitle': 'Kích thước từ 1.7×2.5m đến 2.5×2.5m — linh hoạt theo nhu cầu và ngân sách của bạn',
  'kiosk.location': 'Vị trí:',
  'kiosk.locationValue': 'Aspazijas Bulvaris 32, Riga, Latvia (Tầng Hầm)',
  'kiosk.hours': 'Giờ mở cửa:',
  'kiosk.hoursValue': '11:00 – 19:00, Thứ Hai – Chủ Nhật',
  'kiosk.swipeHint': 'Vuốt sang để xem thêm',
  'kiosk.mini.name': 'Kiosk Mini',
  'kiosk.mini.size': '1.7 × 2.5 m',
  'kiosk.mini.area': '4.25 m²',
  'kiosk.mini.daily': '10 EUR',
  'kiosk.mini.monthly': '150 EUR',
  'kiosk.mini.badge': 'Tiết kiệm nhất',
  'kiosk.standard.name': 'Kiosk Standard',
  'kiosk.standard.size': '2.5 × 2.5 m',
  'kiosk.standard.area': '6.25 m²',
  'kiosk.standard.daily': '25 EUR',
  'kiosk.standard.monthly': '250 EUR',
  'kiosk.standard.badge': 'Phổ biến nhất',
  'kiosk.office.name': 'Văn Phòng Cho Thuê',
  'kiosk.office.size': 'Từ 20m²',
  'kiosk.office.area': '',
  'kiosk.office.daily': 'Liên hệ',
  'kiosk.office.monthly': 'Liên hệ',
  'kiosk.office.badge': 'Văn phòng',
  'kiosk.perDay': '/ngày',
  'kiosk.perMonth': '/tháng',
  'kiosk.or': 'hoặc',
  'kiosk.contact': 'Báo giá theo nhu cầu',
  'kiosk.popularBadge': '⭐ Được Chọn Nhiều Nhất',
  'kiosk.features.mini': 'Phù hợp bán phụ kiện, trang sức, dịch vụ.',
  'kiosk.features.standard': 'Phù hợp quần áo, thủ công, dụng cụ bếp',
  'kiosk.features.office': 'Phù hợp massage, bán hàng online, tư vấn',
  'kiosk.feature1': 'Quầy trưng bày tiêu chuẩn',
  'kiosk.feature2': 'Điện & nước cơ bản',
  'kiosk.feature3': 'Wifi miễn phí',
  'kiosk.feature4': 'Bao gồm phí cơ sở vật chất',
  'kiosk.feature5': 'Thiết kế không gian riêng tư',
  'kiosk.feature6': 'Hệ thống điện & nước chuyên dụng',
  'kiosk.feature7': 'Wifi & thiết bị hỗ trợ',
  'kiosk.feature8': 'Tư vấn vận hành chuyên sâu',
  'kiosk.cta': 'Đăng Ký Kiosk Này',
  'kiosk.promo.badge': '🔥 Ưu Đãi Có Hạn',
  'kiosk.promo.period': 'Đăng ký từ',
  'kiosk.promo.to': 'đến',
  'kiosk.promo.desc': 'Nhận ngay ưu đãi giảm giá thuê trong',
  'kiosk.promo.months': 'tháng 4, 5, 6',
  'kiosk.promo.discount1': 'Giảm 30%',
  'kiosk.promo.discount1Type': 'theo ngày',
  'kiosk.promo.discount2': 'Giảm 20%',
  'kiosk.promo.discount2Type': 'theo tháng',
  'kiosk.note': '* Giá chưa bao gồm VAT 21%. Giá có thể thay đổi theo vị trí và thời điểm. Liên hệ để nhận báo giá chính xác nhất.',

  // Add-on Services Section
  'addon.badge': 'Dịch Vụ Cộng Kèm',
  'addon.title': 'Gói Hỗ Trợ',
  'addon.titleHighlight': 'Kinh Doanh',
  'addon.subtitle': 'Các gói dịch vụ bổ sung giúp bạn vận hành kinh doanh chuyên nghiệp, đúng luật và hiệu quả tại Latvia',
  'addon.flipHint': 'Nhấn vào thẻ để xem chi tiết gói',
  'addon.flipViewFeatures': 'Nhấn để xem',
  'addon.flipFeaturesCount': 'tính năng',
  'addon.starter.name': 'STARTER',
  'addon.starter.subtitle': 'Hỗ Trợ Khởi Nghiệp',
  'addon.starter.price': '30',
  'addon.starter.badge': 'Dành cho người mới',
  'addon.business.name': 'BUSINESS',
  'addon.business.subtitle': 'Kinh Doanh Chuyên Nghiệp',
  'addon.business.price': '60',
  'addon.business.badge': 'Phổ biến nhất',
  'addon.premium.name': 'PREMIUM',
  'addon.premium.subtitle': 'Kinh Doanh Toàn Diện',
  'addon.premium.price': '100',
  'addon.premium.badge': 'Toàn diện nhất',
  'addon.perMonth': 'EUR/tháng',
  'addon.popularBadge': '⭐ Được Chọn Nhiều Nhất',
  'addon.feature.starter1': 'Hỗ trợ đăng ký self-employed',
  'addon.feature.starter2': 'Hướng dẫn mở tài khoản ngân hàng (Revolut / Wise)',
  'addon.feature.starter3': 'Hướng dẫn nhận thanh toán thẻ',
  'addon.feature.starter4': 'Tư vấn cơ bản về thuế',
  'addon.feature.starter5': 'Phù hợp với người mới bắt đầu',
  'addon.feature.business1': 'Tất cả gói Starter',
  'addon.feature.business2': 'Dịch vụ khai thuế hàng tháng',
  'addon.feature.business3': 'Hỗ trợ làm việc với cơ quan thuế',
  'addon.feature.business4': 'Đăng sản phẩm quảng bá trên kênh Asian Alley Mini Mall 3 lần/tháng',
  'addon.feature.premium1': 'Tất cả trong gói Business',
  'addon.feature.premium2': 'Quảng cáo sản phẩm hàng tuần',
  'addon.feature.premium3': 'Hỗ trợ tìm nguồn hàng Châu Á',
  'addon.feature.premium4': 'Kết nối SumUp thanh toán thẻ',
  'addon.feature.premium5': 'Đăng sản phẩm quảng bá trên kênh Asian Alley Mini Mall 10 lần/tháng',
  'addon.feature.premium6': 'Đăng tuyển nhân viên bán hàng',
  'addon.flipBack': 'Quay lại',
  'addon.flipCta': 'Đăng Ký Gói Này',
  'addon.extras.title': 'Chi Phí Dịch Vụ Bổ Sung Tùy Chọn',
  'addon.extras.subtitle': 'Các dịch vụ lẻ theo nhu cầu — báo giá riêng',
  'addon.extra1': 'Đăng ký self-employed',
  'addon.extra2': 'Khai thuế 1 lần',
  'addon.extra3': 'Quảng cáo Facebook',
  'addon.extra4': 'Thiết kế kiosk',
  'addon.extra5': 'Bảng hiệu kiosk',
  'addon.cta': 'Liên Hệ Báo Giá',
  'addon.note': '* Giá chưa bao gồm VAT 21%. Liên hệ để được tư vấn gói phù hợp nhất.',

  // Support Section
  'support.badge': 'Hỗ Trợ Toàn Diện',
  'support.title': 'Chúng Tôi Hỗ Trợ',
  'support.titleHighlight': 'Bạn Mọi Thứ',
  'support.subtitle': 'Từ giấy tờ, ngôn ngữ đến vận hành — Asian Alley đồng hành cùng bạn từ ngày đầu tiên',
  'support.doc.title': 'Hỗ Trợ Giấy Tờ',
  'support.doc.desc': 'Chúng tôi hướng dẫn và hỗ trợ toàn bộ thủ tục đăng ký kinh doanh, giấy phép hoạt động tại Latvia theo đúng quy định pháp luật.',
  'support.lang.title': 'Hỗ Trợ Ngôn Ngữ',
  'support.lang.desc': 'Đội ngũ thông dịch viên tiếng Việt - tiếng Latvia - tiếng Anh hỗ trợ giao tiếp với khách hàng và cơ quan chức năng.',
  'support.space.title': 'Không Gian Sẵn Sàng',
  'support.space.desc': 'Kiosk được trang bị cơ bản, điện nước đầy đủ, wifi tốc độ cao — bạn chỉ cần mang hàng đến và bắt đầu bán.',
  'support.community.title': 'Cộng Đồng Kinh Doanh',
  'support.community.desc': 'Tham gia cộng đồng các chủ kiosk người Châu Á tại Riga — chia sẻ kinh nghiệm, hỗ trợ nhau cùng phát triển.',
  'support.marketing.title': 'Marketing & Quảng Bá',
  'support.marketing.desc': 'Asian Alley tổ chức các sự kiện, chương trình khuyến mãi định kỳ thu hút hàng nghìn khách tham quan mỗi tháng.',
  'support.security.title': 'An Toàn & Bảo Mật',
  'support.security.desc': 'Hệ thống camera an ninh 24/7, bảo vệ chuyên nghiệp — tài sản và hàng hóa của bạn luôn được bảo vệ tuyệt đối.',

  // Gallery Section
  'gallery.badge': 'Hình Ảnh Thực Tế',
  'gallery.title': 'Không Gian',
  'gallery.titleHighlight': 'Chợ Hẻm',
  'gallery.subtitle': 'Khám phá không gian kinh doanh sôi động, ấm cúng mang đậm bản sắc Châu Á',

  // CTA Banner Section
  'ctaBanner.title': 'Đừng Để Mất Vị Trí Đẹp!',
  'ctaBanner.subtitle': 'Số lượng kiosk tại Chợ Hẻm Asian Alley có hạn. Hãy đăng ký ngay hôm nay để được tư vấn miễn phí và chọn vị trí tốt nhất.',
  'ctaBanner.price': 'Chỉ từ 10 EUR/ngày — Bắt đầu kinh doanh ngay tại châu Âu!',
  'ctaBanner.cta': 'Đăng Ký Ngay — Miễn Phí Tư Vấn',
  'ctaBanner.phone': 'Gọi Ngay: +371 2572 6969',

  // Register Form Section
  'register.badge': 'Đăng Ký Ngay',
  'register.title.line1': 'Đặt Chỗ Kiosk',
  'register.title.line2': 'Vị Trí Tốt Nhất',
  'register.subtitle': 'Số lượng kiosk có hạn — hãy đăng ký sớm để chọn được vị trí đẹp nhất trong Chợ Hẻm Asian Alley. Chúng tôi sẽ liên hệ tư vấn miễn phí trong vòng 24 giờ.',
  'register.info.location.title': 'Địa Điểm',
  'register.info.location.value': 'Krisjana Barona Iela 96/98, Riga, Latvia',
  'register.info.hours.title': 'Giờ Hoạt Động',
  'register.info.hours.value': 'Thứ 2 – Chủ Nhật: 10:00 – 20:00',
  'register.info.hotline.title': 'Hotline',
  'register.info.hotline.value': '+371 2572 6969',
  'register.info.email.title': 'Email',
  'register.info.email.value': 'contact@thedaeg.com',
  'register.promo.title': '🔥 Ưu đãi đặc biệt',
  'register.promo.desc': 'Đăng ký trong tháng này — miễn phí 1 tuần thuê đầu tiên và được hỗ trợ setup kiosk hoàn toàn miễn phí!',
  'register.form.title': 'Điền Thông Tin Đăng Ký',
  'register.form.name': 'Họ và Tên',
  'register.form.namePlaceholder': 'Nguyễn Văn A',
  'register.form.phone': 'Số Điện Thoại',
  'register.form.phonePlaceholder': '+84 hoặc +371...',
  'register.form.email': 'Email',
  'register.form.emailPlaceholder': 'email@example.com',
  'register.form.kioskType': 'Loại Kiosk Quan Tâm',
  'register.form.kioskTypePlaceholder': '-- Chọn loại kiosk --',
  'register.form.kioskGroup.daily': '📅 Thuê Theo Ngày',
  'register.form.kioskGroup.monthly': '📆 Thuê Theo Tháng',
  'register.form.kioskMiniDaily': 'Kiosk Mini (1.7×2.5m) — 10 EUR/ngày',
  'register.form.kioskStandardDaily': 'Kiosk Standard (2.5×2.5m) — 25 EUR/ngày',
  'register.form.kioskMiniMonthly': 'Kiosk Mini (1.7×2.5m) — 150 EUR/tháng',
  'register.form.kioskStandardMonthly': 'Kiosk Standard (2.5×2.5m) — 250 EUR/tháng',
  'register.form.kioskOfficeRent': 'Văn Phòng Cho Thuê (từ 20m²) — Liên hệ báo giá',
  'register.form.product': 'Mặt Hàng / Dịch Vụ Dự Kiến',
  'register.form.productPlaceholder': '-- Chọn ngành hàng --',
  'register.form.productCraft': 'Thủ công mỹ nghệ',
  'register.form.productClothing': 'Quần áo & vải vóc',
  'register.form.productJewelry': 'Trang sức & phụ kiện',
  'register.form.productKitchen': 'Dụng cụ nhà bếp',
  'register.form.productService': 'Dịch vụ (cắt tóc, làm móng...)',
  'register.form.productOther': 'Khác',
  'register.form.addonTitle': 'Gói Hỗ Trợ Kinh Doanh (Tùy Chọn)',
  'register.form.addonPlaceholder': '-- Chọn gói hỗ trợ --',
  'register.form.addonNone': 'Không cần gói hỗ trợ',
  'register.form.addonStarter': 'STARTER — 30 EUR/tháng (Hỗ trợ khởi nghiệp)',
  'register.form.addonBusiness': 'BUSINESS — 60 EUR/tháng (Kinh doanh chuyên nghiệp)',
  'register.form.addonPremium': 'PREMIUM — 100 EUR/tháng (Kinh doanh toàn diện)',
  'register.form.extrasTitle': 'Dịch Vụ Bổ Sung Tùy Chọn',
  'register.form.extrasSubtitle': 'Chọn các dịch vụ lẻ bạn quan tâm (có thể chọn nhiều)',
  'register.form.extraSelfEmployed': 'Đăng ký self-employed',
  'register.form.extraTaxFiling': 'Khai thuế 1 lần',
  'register.form.extraFacebook': 'Quảng cáo Facebook',
  'register.form.extraKioskDesign': 'Thiết kế kiosk',
  'register.form.extraKioskSign': 'Bảng hiệu kiosk',
  'register.form.message': 'Ghi Chú Thêm',
  'register.form.messagePlaceholder': 'Câu hỏi hoặc yêu cầu đặc biệt của bạn... (tối đa 500 ký tự)',
  'register.form.messageLimit': '/500',
  'register.form.required': '*',
  'register.form.submit': '🏪 Đăng Ký Thuê Kiosk Ngay',
  'register.form.submitting': 'Đang gửi...',
  'register.success': '✅ Đăng ký thành công! Chúng tôi sẽ liên hệ với bạn trong vòng 24 giờ.',
  'register.error': '❌ Có lỗi xảy ra. Vui lòng thử lại hoặc liên hệ trực tiếp qua hotline.',
  'register.note': 'Miễn phí tư vấn — Không ràng buộc — Phản hồi trong 24 giờ',

  // Page Meta
  'meta.title': 'Chợ Hẻm Asian Alley – Thuê Kiosk Kinh Doanh Hàng Châu Á tại Riga Latvia | The Daeg International',
  'meta.description': 'Thuê Kiosk kinh doanh hàng Châu Á tại Chợ Hẻm Asian Alley Mini Mall – Riga, Latvia. Kích thước 1.7×2.5m đến 2.5×2.5m, giá chỉ từ 20 EUR/ngày hoặc 250 EUR/tháng. Hỗ trợ giấy tờ, ngôn ngữ, vận hành toàn diện.',
  'meta.keywords': 'chợ hẻm asian alley, thuê kiosk riga latvia, kinh doanh hàng châu á châu âu, kiosk mini mall latvia, asian alley mini mall',
};